export const DO_IT_LATER = 'DO_IT_LATER';

export type UserReducerState = {
  doItLater: boolean;
};

export type UserActions = { type: 'DO_IT_LATER' };
